import { useRef } from 'react'
import classes from './reviewCard.module.css'

const ReviewCard = ({
  userName,
  userSubtitle,
  reviewText,
  cardPosition,
  profileImage,
  config
}) => {
  const cardRef = useRef(null)

  // useEffect(() => {
  //   cardRef.current.style.transform = `translateX(${
  //     (cardPosition % 3) * 300
  //   }px)`
  //   if (cardPosition > 2) {
  //     let height = 0
  //     let currentNum = 0
  //     while (currentNum < cardPosition) {
  //       height += 300
  //       currentNum += 3
  //     }

  //     console.log({ height, cardPosition, currentNum })
  //   }
  // }, [cardRef])

  const getCardSize = (size) => {
    switch (size) {
      case 'small':
        return '250px'

      case 'medium':
        return '300px'

      case 'large':
        return '350px'

      default:
        return '300px'
    }
  }

  return (
    <div
      ref={cardRef}
      id={`card-${cardPosition}`}
      className={classes.cardContainer}
      style={{
        width: getCardSize(config.cardSize),
        backgroundColor: config?.cardColor,
        color: config.textColor
      }}
    >
      <div className={classes.userNameContainer}>
        <img src={profileImage} />
        <div>
          <p>{userName}</p>
          <p>{userSubtitle}</p>
        </div>
      </div>
      <p>{reviewText}</p>
    </div>
  )
}

export default ReviewCard
